<template>
  <v-container>
    <v-row>
      <v-col cols="5">
        <v-select id="backendStorageStatsCriteriaForVolumeType"
          v-model="criteria.volumeType"
          :items="listOfVolumes"
          item-text="caption"
          item-value="value"
          label="Volume Type"
          @change="getBackendStorageStats"
          >
        </v-select>
      </v-col>
    </v-row>
    <v-data-table
      :items="backendStorageStatsDetails"
      :headers="tableHeader"
      class="elevation-1"
      :items-per-page="itemsPerPage"
      hide-default-footer
    >
    </v-data-table>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'BackendStorageStats',
  components: {},
  data: () => ({
    criteria: {
      volumeType: '',
    },
    backendStorageStatsDetails: [],
    tableHeader: [
      { text: 'Filesystem', value: 'filesystem' },
      { text: 'Size', value: 'size' },
      { text: 'Used', value: 'used' },
      { text: 'Avail', value: 'avail' },
      { text: 'Use%', value: 'usePercentage' },
      { text: 'Mounted on', value: 'mountedOn' },
    ],
    listOfVolumes: [
      { caption: 'All Volumes', value: '' },
      { caption: 'Backend File Data (Main)', value: 'backendDataFiles' },
      { caption: 'User Scanned File Storage (Temporary)', value: 'uploadstgFiles' },
    ],
    itemsPerPage: 50, // Just a rough limit
  }),
  created() {
    this.getBackendStorageStats();
  },
  computed: {},
  methods: {
    ...mapActions('systemInfo', ['backendStorageStats']),
    async getBackendStorageStats() {
      const result = await this.backendStorageStats({ criteria: this.criteria });
      this.backendStorageStatsDetails = (result || {}).pvcRawParsedResult || [];
    },
  },
};

</script>
